























































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import { maskDateTime, onlyNumber } from '@/utils/common'
import SuporteHospitaisRemuneracaoStore from '../store/SuporteHospitaisRemuneracaoStore'
import AuditLogHistory from '@/components/shared/AuditLogHistory.vue'

@Component({
  components: {
    AuditLogHistory
  }
})
export default class ModalSuporteVisualizarGrupo extends Vue {
  @Prop({ default: false }) visualizar!: boolean

  activeTab: number = 0


  tiposDeCargaTextarea: string = ''
  loadSaveOrUpdateHospital: boolean = false

  getSuporteHospitaisRemuneracaoStore = getModule(SuporteHospitaisRemuneracaoStore, this.$store)

  get loadingSaveOrUpdateHospital() { return this.loadSaveOrUpdateHospital }
  set loadingSaveOrUpdateHospital(value: boolean) { this.loadSaveOrUpdateHospital = value }

  get hospitalDetails() {
    return this.getSuporteHospitaisRemuneracaoStore.grupoHospitalDetails
  }

  get selectedTiposDeCarga() {
    return this.hospitalDetails.tiposDeCarga
  }

  set selectedTiposDeCarga(value: any) {
    this.getSuporteHospitaisRemuneracaoStore.setTiposCargaSelected(value)
  }

  get selectedCalculoModoDisparo() {
    return this.hospitalDetails.calculoModoDisparo
  }

  set selectedCalculoModoDisparo(value: any) {
    this.hospitalDetails.calculoModoDisparo = value
    this.getSuporteHospitaisRemuneracaoStore.setCalculoModoDisparoSelected(value)
  }

  get createdOn() {
    return this.formatDateTime(this.hospitalDetails.createdOn)
  }

  get showModalHospital() {
    return this.getSuporteHospitaisRemuneracaoStore.modal.visualizarGrupo
  }

  set showModalHospital(value: boolean) {
    this.getSuporteHospitaisRemuneracaoStore.setModal({ name: 'visualizarGrupo', value })
  }

  loadingData: boolean = false
  expansionKey: number = 0

  @Watch('showModalHospital')
  onShowModalChange(val: boolean) {
    if (!val) {
      this.loadingData = false
      this.activeTab = 0
      return
    }
    this.loadingData = true
    setTimeout(() => {
      this.loadingData = false
    }, 2000)
  }

  @Watch('getSuporteHospitaisRemuneracaoStore.grupoHospitalDetails')
  onDetailsChange(newVal: any) {
    if (this.showModalHospital) {
      if (newVal && newVal.id) this.loadingData = false
    }
  }

  formatDateTime(date: string) {
    return maskDateTime(date)
  }

  onlyNumberUtil(e: KeyboardEvent) {
    return onlyNumber(e)
  }

  onChangeCalculoAtivo(value?: boolean) {
    const ativo = typeof value === 'boolean' ? value : this.hospitalDetails.calculoAtivo
    if (ativo) {
      this.selectedCalculoModoDisparo = 'GeracaoDeRepassesNovoCalculo'
    }
  }

  async saveOrUpdateHospital() {
    this.loadingSaveOrUpdateHospital = true
    if (this.hospitalDetails.id) {
      await this.getSuporteHospitaisRemuneracaoStore.updateGrupoHospital()
      this.closeModal()
    } else {
      await this.getSuporteHospitaisRemuneracaoStore.createGrupoHospital()
      this.closeModal()
    }
    this.loadingSaveOrUpdateHospital = false
  }

  async closeModal() {
    await this.getSuporteHospitaisRemuneracaoStore.getGrupoHospital()
    this.getSuporteHospitaisRemuneracaoStore.clearHospitaisDetails()
    this.expansionKey++
    this.showModalHospital = false
  }
}
